// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LandingPage_pageContainer__8AW5r {
  min-height: 100vh;
  background-color: var(--neutral-light-gray);
}

/*
 * Brand Banner (featured MedXCom branding)
 */
.LandingPage_brandBanner__8MR9G {
  background: linear-gradient(120deg, var(--primary-dark-blue) 0%, var(--primary-dark-blue) 55%, var(--secondary-bright-blue) 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 26px 20px;
  box-shadow: 0 2px 12px rgba(31, 42, 92, 0.15);
}

.LandingPage_brandLogo__VA3OX {
  height: 46px;
  width: auto;
}

/*
 * Title Block (page title + friendly subtitle, centered)
 */
.LandingPage_titleBlock__3bQ8e {
  text-align: center;
  padding: 28px 20px 8px;
}

.LandingPage_pageTitle__CgkOY {
  font-size: 2rem;
  font-weight: 700;
  color: var(--primary-dark-blue);
  margin: 0;
  letter-spacing: -0.01em;
}

.LandingPage_pageSubtitle__FyUHU {
  font-size: 1.05rem;
  color: #5b6472;
  margin: 8px 0 0;
}

/*
 * Main Content
 */
.LandingPage_mainContent__ScYMg {
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px 20px 60px 20px;
  background-color: var(--neutral-light-gray);
}

/*
 * Responsive Adjustments
 */
@media (max-width: 768px) {
  /* App shell: lock the page to the viewport height so the registration
     form owns its own scroll area and the nav footer stays pinned to the
     bottom of the screen. The flex chain continues into
     RegistrationForm.module.css (.formLayoutWrapper -> .formContent). */
  .LandingPage_pageContainer__8AW5r {
    /* Clear the base min-height: 100vh so it can't override the dvh height
       and reintroduce page scroll when mobile browser chrome is visible */
    min-height: 0;
    height: 100vh;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .LandingPage_brandBanner__8MR9G {
    flex-shrink: 0;
    padding: 16px 20px;
  }

  .LandingPage_brandLogo__VA3OX {
    height: 34px;
  }

  .LandingPage_titleBlock__3bQ8e {
    flex-shrink: 0;
    padding: 14px 20px 6px;
  }

  .LandingPage_pageTitle__CgkOY {
    font-size: 1.4rem;
  }

  /* Subtitle is desktop-only breathing room; hide on mobile to preserve
     vertical space for the scrollable form area */
  .LandingPage_pageSubtitle__FyUHU {
    display: none;
  }

  .LandingPage_mainContent__ScYMg {
    flex: 1 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LandingPage/LandingPage.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;;EAEE;AACF;EACE,iIAAiI;EACjI,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE;AACF;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE;AACF;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;;EAEE;AACF;EACE;;;wEAGsE;EACtE;IACE;0EACsE;IACtE,aAAa;IACb,aAAa;IACb,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;kDACgD;EAChD;IACE,aAAa;EACf;;EAEA;IACE,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;EACZ;AACF","sourcesContent":[".pageContainer {\n  min-height: 100vh;\n  background-color: var(--neutral-light-gray);\n}\n\n/*\n * Brand Banner (featured MedXCom branding)\n */\n.brandBanner {\n  background: linear-gradient(120deg, var(--primary-dark-blue) 0%, var(--primary-dark-blue) 55%, var(--secondary-bright-blue) 100%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 26px 20px;\n  box-shadow: 0 2px 12px rgba(31, 42, 92, 0.15);\n}\n\n.brandLogo {\n  height: 46px;\n  width: auto;\n}\n\n/*\n * Title Block (page title + friendly subtitle, centered)\n */\n.titleBlock {\n  text-align: center;\n  padding: 28px 20px 8px;\n}\n\n.pageTitle {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--primary-dark-blue);\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.pageSubtitle {\n  font-size: 1.05rem;\n  color: #5b6472;\n  margin: 8px 0 0;\n}\n\n/*\n * Main Content\n */\n.mainContent {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 20px 20px 60px 20px;\n  background-color: var(--neutral-light-gray);\n}\n\n/*\n * Responsive Adjustments\n */\n@media (max-width: 768px) {\n  /* App shell: lock the page to the viewport height so the registration\n     form owns its own scroll area and the nav footer stays pinned to the\n     bottom of the screen. The flex chain continues into\n     RegistrationForm.module.css (.formLayoutWrapper -> .formContent). */\n  .pageContainer {\n    /* Clear the base min-height: 100vh so it can't override the dvh height\n       and reintroduce page scroll when mobile browser chrome is visible */\n    min-height: 0;\n    height: 100vh;\n    height: 100dvh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  .brandBanner {\n    flex-shrink: 0;\n    padding: 16px 20px;\n  }\n\n  .brandLogo {\n    height: 34px;\n  }\n\n  .titleBlock {\n    flex-shrink: 0;\n    padding: 14px 20px 6px;\n  }\n\n  .pageTitle {\n    font-size: 1.4rem;\n  }\n\n  /* Subtitle is desktop-only breathing room; hide on mobile to preserve\n     vertical space for the scrollable form area */\n  .pageSubtitle {\n    display: none;\n  }\n\n  .mainContent {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `LandingPage_pageContainer__8AW5r`,
	"brandBanner": `LandingPage_brandBanner__8MR9G`,
	"brandLogo": `LandingPage_brandLogo__VA3OX`,
	"titleBlock": `LandingPage_titleBlock__3bQ8e`,
	"pageTitle": `LandingPage_pageTitle__CgkOY`,
	"pageSubtitle": `LandingPage_pageSubtitle__FyUHU`,
	"mainContent": `LandingPage_mainContent__ScYMg`
};
export default ___CSS_LOADER_EXPORT___;
